import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mappedUpdateSignerData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateExecutiveSignerMutation = (
	creditReviewId: string,
	refetchExecutiveSignerInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
			setActionFormState,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: Function;
		}) => {
			return creditReviewDetailsService.updateSignerInfo(
				creditReviewId,
				mappedUpdateSignerData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchExecutiveSignerInfo();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateExecutiveSignerMutation;
